export default __webpack_public_path__ + "static/media/search-background.74f7f715.png";